import categories1 from '../images/categories/1.jpeg'
import categories2 from '../images/categories/2.jpeg'
import categories3 from '../images/categories/3.jpeg'
import categories4 from '../images/categories/4.jpeg'
import categories5 from '../images/categories/5.jpeg'
import categories6 from '../images/categories/6.jpeg'
import categories7 from '../images/categories/7.jpeg'
import categories8 from '../images/categories/8.jpeg'
import categories9 from '../images/categories/8.jpeg'
import categories10 from '../images/categories/8.jpeg'
import categories11 from '../images/categories/8.jpeg'
import categories12 from '../images/categories/8.jpeg'
import categories13 from '../images/categories/8.jpeg'

const categoriesData=[{
    image: categories1,
    product: 13,
    title : "DJ Equipments / DJ Controllers"
    
},
{
    image: categories2,
    product:110,
    title: "Guitar Accessories"
},
{
    image: categories3,
    product : 29,
    title: "Guitar Amplifier"

},
{
    image: categories4,
    product : 58,
    title: "Guitars"
},
{
    image: categories5,
    product : 30,
    title: "Keyboard"
},
{
    image: categories6,
    product : 29,
    title: "Miscellaneous Products"
},
{
    image: categories7,
    product : 10,
    title: "Other Instrument"
},
{
    image: categories8,
    product : 13,
    title: "Pedal"
},
{
    image: categories9,
    product : 12,
    title: "Percussion"
},
{
    image: categories10,
    product : 43,
    title: "Percussion Accessories"
},
{
    image: categories11,
    product : 34,
    title: "Strings"
},
{
    image: categories12,
    product : 121,
    title: "Studio Recording Equipments"
},
{
    image: categories13,
    product : 22,
    title: "Ukulele"
}]
export default categoriesData